module.exports = __webpack_public_path__ + "img/8F4E20_E8B06B_391A08_CC8944-256px.b3dc8fb2.png";